module.exports = [
  // 忘記帳號(slice(0, 2)))
  { 
    "input_name":"phone_number",
    "input_title":"手機號碼",
    "input_type":"text",
    "input_id":"phone",
    "error":"",
    "placeholder":"",
    "check":"請輸入正確email",
    "require":"required",
    "reg_exp": "",
    "value":"",
  },
  {
    "input_name":"cid",
    "input_title":"身分證後六碼",
    "input_type":"text",
    "input_id":"cid",
    "error":"",
    "placeholder":"",
    "check":"",
    "require":"required",
    "notice": "",
    "value":'',
  },
  // 忘記密碼(slice(2, 3))
  {
    "input_name":"email",
    "input_title":"E-Mail(帳號)",
    "input_type":"text",
    "input_id":"email",
    "error":"",
    "placeholder":"",
    "check":"請輸入E-mail",
    "require":"required",
    "value":'',
  },
  // 會員註冊(slice(3, 10))
  {
    "input_name":"email",
    "input_title":"E-Mail(帳號)",
    "input_type":"email",
    "input_id":"email",
    "error":"",
    "placeholder":"請輸入E-mail",
    "check":"請輸入E-mail",
    "require":"required",
    "notice":"",
    "notice2": "索票&報名資訊將會寄送至此E-Mail，請避免使用Yahoo、PChome等免費信箱，送出前請確認 E-Mail格式、內容無誤，以免漏失重要會員訊息。",
    "value":'',
  },
  {
    "input_name":"email_verify_code",
    "input_title":"E-mail驗證碼",
    "input_type":"text",
    "input_id":"email_verify_code",
    "error":"",
    "placeholder":"請輸入E-mail驗證碼",
    "check":"請輸入E-mail驗證碼",
    "require":"required",
    "notice": '',
    "notice2": '',
    "value":'',
  },
  {
    "input_name":"password",
    "input_title":"密碼(請注意大小寫)",
    "input_type":"Password",
    "input_id":"password",
    "error":"",
    "placeholder":"請輸入6~12碼，限英文及數字",
    "check":"",
    "require":"required",
    "notice": '',
    "notice2": '',
    "value":'',
  },
  {
    "input_name":"password_check",
    "input_title":"密碼確認(請注意大小寫)",
    "input_type":"password",
    "input_id":"password_check",
    "error":"",
    "placeholder":"請再次輸入密碼",
    "check":"",
    "require":"required",
    "notice":"密碼不一致",
    "notice2":"",
    "value":'',
  },
  {
    "input_name":"name",
    "input_title":"姓名",
    "input_type":"text",
    "input_id":"name",
    "error":"",
    "placeholder":"請輸入姓名",
    "check":"請輸入姓名",
    "require":"required",
    "notice": '',
    "notice2": '',
    "value":'',
  },
  {
    "input_name":"cid",
    "input_title":"身分證末六碼",
    "input_type":"text",
    "input_id":"cid",
    "error":"",
    "placeholder":"請輸入身分證末六碼",
    "check":"請輸入身分證末六碼",
    "require":"required",
    "notice": '',
    "notice2": '',
    "value":'',
  },
  {
    "input_name":"phone_number",
    "input_title":"手機",
    "input_type":"text",
    "input_id":"phone_number",
    "error":"",
    "placeholder":"請輸入手機號碼",
    "check":"請輸入手機號碼",
    "require":"required",
    "notice": '',
    "notice2": '',
    "value":'',
  },
  {
    "input_name":"verify_code",
    "input_title":"手機驗證碼",
    "input_type":"text",
    "input_id":"verify_code",
    "error":"",
    "placeholder":"請輸入手機驗證碼",
    "check":"請輸入手機驗證碼",
    "require":"required",
    "notice": '',
    "notice2": '',
    "value":'',
  },
  // 修改密碼(slice(10, 13))
  {
    "input_name":"old_pass",
    "input_title":"舊密碼(請注意大小寫)",
    "input_type":"Password",
    "input_id":"old_pass",
    "error":"",
    "placeholder":"請輸入6~12碼，限英文及數字",
    "check":"請輸入舊密碼",
    "require":"required",
    "value":'',
  },
  {
    "input_name":"new_pass",
    "input_title":"新密碼(請注意大小寫)",
    "input_type":"Password",
    "input_id":"new_pass",
    "error":"",
    "placeholder":"請輸入6~12碼，限英文及數字",
    "check":"",
    "require":"required",
    "notice": '',
    "notice2": '',
    "value":'',
  },
  {
    "input_name":"new_pass_check",
    "input_title":"密碼確認(請注意大小寫)",
    "input_type":"password",
    "input_id":"new_pass_check",
    "error":"",
    "placeholder":"請再次輸入新密碼",
    "check":"",
    "require":"required",
    "notice":"密碼不一致",
    "notice2":"",
    "value":'',
  },
  // 第三方登入綁定(slice(13, 14))
  // 已有上聯帳號
  {
    "input_name":"email",
    "input_title":"E-Mail(帳號)",
    "input_type":"email",
    "input_id":"email",
    "error":"",
    "placeholder":"請輸入E-mail",
    "check":"請輸入E-mail",
    "require":"required",
    "notice":"",
    "notice2": "",
    "value":'',
  },
  {
    "input_name":"password",
    "input_title":"密碼(請注意大小寫)",
    "input_type":"Password",
    "input_id":"password",
    "error":"",
    "placeholder":"請輸入6~12碼，限英文及數字",
    "check":"",
    "require":"required",
    "notice": '',
    "notice2": '',
    "value":'',
  },
  // 第三方登入綁定(slice(14, 18))
  // 沒有上聯帳號
  {
    "input_name":"residential_area",
    "input_title":"居住區域",
    "input_type":"radio",
    "input_id":"residential_area",
    "input_options": "北部：(臺北市、新北市、基隆市、新竹市、桃園市、新竹縣、宜蘭縣),中部：(臺中市、苗栗縣、彰化縣、南投縣、雲林縣),南部：(高雄市、臺南市、嘉義市、嘉義縣、屏東縣、澎湖縣),東部：(花蓮縣、臺東縣),離島：(金門縣、連江縣)",
    "error":"",
    "check":"",
    "require":"required",
    "notice": '',
    "notice2": '',
    "value":'',
  },
]